/**
 * 보안 파일 저장소 페이지
 * SecureFilesContext와 컴포넌트 통합
 */

import React from 'react';
import { SecureFilesProvider } from '../contexts/SecureFilesContext';
import SecureFilesList from '../components/SecureFiles/SecureFilesList';

function SecureFilesPage() {
  return (
    <SecureFilesProvider>
      <SecureFilesList />
    </SecureFilesProvider>
  );
}

export default SecureFilesPage;